import { i18n as _i18n } from "@lingui/core";
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { useCarleadConfiguration } from '../../hooks/useCarleadCreationConfiguration';
import { BaseField, renderFieldVerticalWrapper } from '../BaseField';
import { selectFieldRenderer } from '../fieldRenderers/selectFieldRenderer';
import { useSyncValues } from '../hooks/useAutoSelectForDataFields';
import { useDynamicCartypesFetcher } from '../hooks/useDynamicCartypesFetcher';
import { useStateMachineForDataFields } from '../hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitManufacturers(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.manufacturer'
    }),
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.manufacturer'
    }),
    className,
    onChange,
    ...props
  } = _ref;
  const name = formNames.manufacturer;
  const {
    country,
    fullLocale
  } = useCarleadConfiguration();
  const {
    carTypesSplitModule: {
      getManufacturers
    }
  } = useModulesStore();
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames
  } = useStateMachineForDataFields({
    name
  });
  const {
    data
  } = useDynamicCartypesFetcher({
    name,
    enabled: isFieldEnabled,
    queryFn: getManufacturers,
    params: {
      country,
      locale: fullLocale
    }
  });
  useSyncValues(name);
  return /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: name,
    disabled: !isFieldEnabled,
    MktSelector: MktSelectors.manufacturer,
    topContainerClassName: stateFieldClassNames,
    renderFieldWrapper: renderFieldVerticalWrapper,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        name,
        mktSelector
      } = _ref2;
      return selectFieldRenderer({
        name,
        mktSelector,
        placeholder,
        className,
        options: data,
        onChange(evt) {
          onChange === null || onChange === void 0 || onChange(evt);
          sendUserSelect(evt.target.value);
        }
      });
    },
    ...props
  });
}